import type { IconSvgObject } from './types';

const BookOpen01Icon: IconSvgObject = [
  ["path", { d: "M18.6667 3.00001C16.2062 2.99657 13.8315 3.88709 12 5.5V21C13.8315 19.3871 16.2062 18.4966 18.6667 18.5C19.8356 18.5 20.9578 18.6963 22 19.0585V3.55847C20.9578 3.19634 19.8356 3.00001 18.6667 3.00001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.33333 3.00001C7.79379 2.99657 10.1685 3.88709 12 5.5V21C10.1685 19.3871 7.79379 18.4966 5.33333 18.5C4.16444 18.5 3.04222 18.6963 2 19.0585V3.55847C3.04222 3.19634 4.16444 3.00001 5.33333 3.00001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookOpen01Icon;
